import { authenticate, isAuthenticated } from "../../services/auth"
import endPoints from "../../services/endPoints"
import postApi from "../../services/postApi"
import { showToastAction } from "../slices/commonSlice"

const LoginAction = (payload, dispatch, setLoading, navigate) => async () => {
    setLoading(true)
    const res = await postApi(endPoints.LOGIN, payload)
    if (res?.success) {
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
        authenticate(res?.data?.token, () => {
            if (isAuthenticated()) {
                navigate("/dashboard");
            } else {
                navigate("/");
            }
        })
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

const RegisterAction = (data, setLoading, dispatch, navigate, onRes) => async () => {
    setLoading(true)
    const payload = {
        email: data?.email,
        fullName: data?.name,
        password: data?.password,
        confirmPassword: data?.confirmPassword,
        iAgree: data?.iAgree,
        updateIO: data?.updateIO
    }

    const res = await postApi(endPoints.REGISTER, payload)
    if (res?.success) {
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
        onRes && onRes(res?.data)
        authenticate(res?.data?.token, () => {
            if (isAuthenticated()) {
                navigate("/dashboard");
            } else {
                navigate("/");
            }
        })
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

const requestOtpAction = (data, setLoading, dispatch, onRes) => async () => {
    setLoading && setLoading(true)
    const res = await postApi(endPoints.REQUEST_OTP, data)
    if (res?.success) {
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
        onRes && onRes(res)
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading && setLoading(false)
}

const verifyOtpAction = (data, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    const res = await postApi(endPoints.VERIFY_OTP, data)
    if (res?.success) {
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
        onRes && onRes(res)
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

const forgotPasswordAction = (data, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    const res = await postApi(endPoints.FORGOT_PASSWORD, data)
    if (res?.success) {
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
        onRes && onRes(res)
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

const resetPasswordAction = (data, setLoading, dispatch, navigate, onRes) => async () => {
    setLoading(true)
    const res = await postApi(endPoints.RESET_PASSWORD, data)
    if (res?.success) {
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
        onRes && onRes(res)
        navigate("/")
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

export {
    LoginAction,
    RegisterAction,
    requestOtpAction,
    verifyOtpAction,
    forgotPasswordAction,
    resetPasswordAction,
}